import __base_store from '@/store/__base_store'

/**
 * Store de descripciones de nota de crédito (modelo `nota_credito_description`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'nota_credito_description',
	},
})

